import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing an alarm
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AlarmIcon width={12} />
 */
const AlarmIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M10.8889 0.999999L10.8889 5.44444L9.11111 5.44444L9.11111 0.999999L10.8889
            0.999999ZM3.71111 3.24444L6.86667 6.37778L5.6 7.64444L2.46667 4.48889L3.71111
            3.24444ZM16.2889 3.24444L17.5333 4.48889L14.4 7.64444L13.1333 6.37778L16.2889
            3.24444ZM16.2222 15.2222L16.2222 14.3333L3.77778 14.3333L3.77778 15.2222L16.2222
            15.2222ZM13.4667 12.5556L13.2 11.6667L6.8 11.6667L6.53333 12.5556L13.4667 12.5556ZM13.2
            9.88889C13.5852 9.88889 13.9333 10.0037 14.2444 10.2333C14.5556 10.463 14.7704 10.763 14.8889
            11.1333L15.3333 12.5556L16.2222 12.5556C16.7111 12.5556 17.1296 12.7296 17.4778
            13.0778C17.8259 13.4259 18 13.8444 18 14.3333L18 17L2 17L2 14.3333C2 13.8444 2.17407 13.4259
            2.52222 13.0778C2.87037 12.7296 3.28889 12.5556 3.77778 12.5556L4.66667 12.5556L5.24444
            11.0444C5.37778 10.7037 5.59259 10.4259 5.88889 10.2111C6.18519 9.99629 6.51852 9.88889
            6.88889 9.88889L13.2 9.88889Z`}
        />
    </SvgIcon>
)

AlarmIcon.defaultProps = defaultProps

export { AlarmIcon }
